const SessionTypeDetail = `
  fragment SessionTypeDetail on SessionTypeDetail {
    sessionType
    sessionTypeId
    url
  }
`
export default SessionTypeDetail
